<template>
  <v-hover
    v-slot:default="{ hover }"
  >
    <BaseMyCard
      v-on="$listeners"
      v-bind="$attrs"
      class="mb-2 py-5"
      :hover="hover"
      :scale="1.02"
      :ripple="false"
      style="cursor: auto !important"
    >
      <v-container>
        <v-row>
          <v-col class="d-flex justify-center">
            <v-btn style="cursor: auto !important" small fab depressed :class="`${item.color}--text`" :color="`${item.color} lighten-5`">
              <v-icon>{{ item.icon }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex justify-center display-3 font-weight-bold py-0">
            {{ item.total }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex justify-center subtitle-1 grey--text font-weight-bold pt-0">
            {{ item.title }}
          </v-col>
        </v-row>
      </v-container>
    </BaseMyCard>
  </v-hover>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style>

</style>